type Translate = (key: string, options?: Record<string, string>) => string;

const pad = (value: string) => value.padStart(2, "0");
const isNumber = (value: string) => /^\d+$/.test(value);

/**
 * Turns the common cron expressions into readable text ("Every day at 08:00").
 * Anything more exotic is returned as null, and the raw expression is shown instead.
 */
export const describeCron = (expression: string, t: Translate): string | null => {
  const parts = expression.trim().split(/\s+/);
  if (parts.length !== 5) return null;
  const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;
  const everyDay = dayOfMonth === "*" && month === "*";

  if (parts.every((part) => part === "*")) return t("cronJobs.describe.everyMinute");
  if (/^\*\/\d+$/.test(minute) && hour === "*" && everyDay && dayOfWeek === "*") {
    return t("cronJobs.describe.everyNMinutes", { n: minute.slice(2) });
  }
  if (isNumber(minute) && hour === "*" && everyDay && dayOfWeek === "*") {
    return t("cronJobs.describe.hourly", { minute: pad(minute) });
  }
  if (isNumber(minute) && isNumber(hour) && everyDay) {
    const time = `${pad(hour)}:${pad(minute)}`;
    if (dayOfWeek === "*") return t("cronJobs.describe.daily", { time });
    if (dayOfWeek === "1-5") return t("cronJobs.describe.weekdays", { time });
    return t("cronJobs.describe.onWeekdays", { time, days: dayOfWeek });
  }
  return null;
};

export const cronPresets = [
  { key: "every10Minutes", schedule: "*/10 * * * *" },
  { key: "hourly", schedule: "0 * * * *" },
  { key: "daily8", schedule: "0 8 * * *" },
  { key: "daily9", schedule: "0 9 * * *" },
  { key: "weekdays14", schedule: "0 14 * * 1-5" },
];
